export default "__VITE_ASSET__113369c1__"